export default __webpack_public_path__ + "static/latitude-pay-video@3x-8d2e016cf2b52c5e2e3c6dc911cddfea.png";